import styled from 'styled-components';

const Spacer = styled.div`
  height: ${(props) => (props.height ? props.height : '25px')};
  width: 100%;
  background: ${(props) => (props.white ? 'white' : 'none')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 'none')};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : 'none'};
  @media (max-width: 425px) {
    height: 15px;
  }
`;

export default Spacer;
